import { useLang } from "@/context/LanguageContext";

export const Footer = () => {
  const { t } = useLang();
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="footer"
      className="relative border-t border-[#222] bg-ink pb-28 pt-20"
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        {/* Massive logo */}
        <div className="font-display tracking-brutal text-[20vw] md:text-[16vw] leading-[0.85] text-wood/80 select-none mb-12">
          CRVD
        </div>

        <div className="grid md:grid-cols-12 gap-8 pt-10 border-t border-[#222]">
          <div className="md:col-span-5">
            <div className="font-display text-2xl uppercase tracking-brutal">
              {t("footer.tagline")}
            </div>
            <div className="font-mono text-[10px] tracking-tech text-bone/50 mt-4">
              {t("footer.cut")}
            </div>
          </div>

          <div className="md:col-span-2">
            <div className="font-mono text-[10px] tracking-tech text-bone/40 mb-3">
              {t("footer.contact")}
            </div>
            <a
              href="mailto:inforuncrvd@gmail.com"
              className="block font-mono text-xs text-bone/80 hover:text-wood"
              data-testid="footer-email"
            >
              inforuncrvd@gmail.com
            </a>
            <a
              href="https://www.instagram.com/runcrvd/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram"
              className="block font-mono text-xs text-bone/80 hover:text-wood mt-1"
            >
              @runcrvd → Instagram
            </a>
          </div>

          <div className="md:col-span-2">
            <div className="font-mono text-[10px] tracking-tech text-bone/40 mb-3">
              {t("footer.policy")}
            </div>
            <a href="#" className="block font-mono text-xs text-bone/80 hover:text-wood">Terms</a>
            <a href="#" className="block font-mono text-xs text-bone/80 hover:text-wood mt-1">Privacy</a>
            <a href="#" className="block font-mono text-xs text-bone/80 hover:text-wood mt-1">Returns</a>
          </div>

          <div className="md:col-span-3">
            <div className="font-mono text-[10px] tracking-tech text-bone/40 mb-3">
              {t("footer.admin")}
            </div>
            <a
              href="/admin"
              data-testid="footer-admin-link"
              className="inline-block font-mono text-xs text-bone/80 hover:text-wood border border-[#333] px-3 py-1.5 hover:border-wood"
            >
              → /admin
            </a>
          </div>
        </div>

        <div className="pt-10 mt-10 border-t border-[#222] font-mono text-[10px] tracking-tech text-bone/40 flex flex-wrap justify-between gap-4">
          <span>© {year} CRVD SRL — MILAN, IT</span>
          <span>{t("footer.rights")}</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
